import * as log from 'loglevel';
import * as _ from "lodash"
import * as ko from 'knockout';
import {getJSON} from 'jquery';
import {ComputedOptions} from "~knockout/index";
import {getPrimaryScreenVisibilityOptions, getSecondaryScreenVisibilityOptions} from "../../ScreenVisibility";
import {Screen} from "../../Screen";
import {hideSecondaryScreens, showPrimaryScreen, showSecondaryScreen} from "../../ScreenManager";
import {getGameManager} from "../../../game/GameManager";
import {ILeaderboardEntry} from 'power-patrol';
import {Observable} from '~knockout/index';
import {globalConfig} from '../../../config/Config';
import {playUiVoiceover} from '../../../audio/voiceovers/VoiceOverManager';

var template = require('./DifficultySelectScreen.html');

var difficultyLevel: number,
    nextQuizState: string = 'sorting-game';

class DifficultySelectScreenComponent extends Screen
{
    difficulty: Observable<number>;


    /**
     * create bindings
     */
    createBindings()
    {
        //  set initial difficulty level

        difficultyLevel = 1;

        //  create observable difficulty

        this.difficulty = ko.observable(1);

        super.createBindings();
    }


    /**
     * get screen visibility computed options
     * @returns {ComputedOptions<boolean>}
     */
    getVisibleOptions() : ComputedOptions<boolean>
    {
        return getPrimaryScreenVisibilityOptions('difficulty-select');
        //return getSecondaryScreenVisibilityOptions('main-menu', 'difficulty-select');
    }


    /**
     * when we show the screen, play a sound clip
     */
    onShow()
    {
        playUiVoiceover('difficulty--take-your-pick');
    }


    /**
     * set the difficulty
     * @param $data
     * @param difficulty
     */
    chooseDifficulty = ($data: any, difficulty: number, value: number) =>
    {
        //  save the new difficulty level

        this.difficulty(parseInt($data));

        //  play the difficulty level VO

        switch (this.difficulty())
        {
            case 0:

                playUiVoiceover('difficulty--easy');

                break;

            case 1:

                playUiVoiceover('difficulty--medium');

                break;

            case 2:

                playUiVoiceover('difficulty--hard');

                break;
        }
    };


    /**
     * confirm and save the new difficulty level
     */
    confirmDifficulty = () =>
    {

        //  close the modal

        showSecondaryScreen(null);
    };


    /**
     * show the gameplay screen and start playing
     */
    startGame()
    {
        //  save the new difficulty level

        difficultyLevel = this.difficulty();

        showPrimaryScreen('gameplay');

        getGameManager().playGame();

        //  play a button sound

        playUiVoiceover('startGame');
    }
}


/**
 * get the current difficulty levels
 * @returns {number}
 */
export function getDifficultyLevel() : number
{
    return difficultyLevel;
}


/**
 * reset the sorting game state
 * @returns {number}
 */
export function resetSortingGame()
{
    nextQuizState = 'sorting-game';
}


/**
 * check whether we should show the sorting game or questions next time we finish a level
 * @returns {number}
 */
export function usingSortingGame() : boolean
{
    if (difficultyLevel == 0) return true;

    if (nextQuizState === 'sorting-game')
    {
        nextQuizState = 'questions';

        return true;
    }
    else
    {
        nextQuizState = 'sorting-game';

        return false;
    }
}


/**
 * register this component with knockout
 */
export function registerDifficultySelectScreenComponent()
{
    ko.components.register('pp-difficulty-select-overlay',
        {
            viewModel: () => { return new DifficultySelectScreenComponent() },
            template: template
        });
}



// WEBPACK FOOTER //
// ./src/ts/screens/main-menu/difficulty-select/DifficultySelectScreen.ts